<template>
  <!--/* 投稿プロジェクト */-->
  <div class="projectPanel">
    <div class="thumbnailCard">
      <a :href="onclickURL" class="projectPanelLink"  @click="onClickProject">
        <div style="padding-left: 0; padding-top: 0; padding-right: 0.5rem; padding-bottom: 0.25rem; overflow:hidden" >
          <!--/*  タイトル  */-->
          <h5 class="projectTitle" style="font-weight: 700; margin-bottom:0" >{{ publicPage.title ? publicPage.title : '(タイトル未設定)' }}</h5>
        </div>
        <!--/* プロジェクトのサムネイル */-->
        <div class="thumbnail-wrap">
          <img 
            v-if="hasImage && urls.getThumbnailURL(publicPage.user.id, publicPage)" 
            class="card-img-top thumbnail" style="border-radius: 0; border:1px solid #999" 
            
            :src="urls.getThumbnailURL(publicPage.user.id, publicPage)" 
            @error="onImageError" 
          />
          <div v-else class="thumbnail-no-image" >
            no image
          </div>
        </div>
        
        <!--/*  プロジェクトの説明  */-->
        <div class="projectDescription">
          {{ shortDescrition }}
        </div>
      </a>


      <!--/*  ユーザー名  */-->
      <div v-if="publicPage.user != null" class="userBlockWrap">
        <UserBlockSmall :dtoUser="publicPage.user"></UserBlockSmall>
      </div>


      <!--/* todo:コメント数や再生数は一旦非表示。そのうち表示させる
      <div style="display: flex; margin-left: 0.25rem">
        <div style="display: flex">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi-chat-left b-icon bi">
            <use :xlink:href="urls.getIconURL('chatleft')" />
          </svg>
          
          <span style="padding-left: 0.25rem">{{ publicPage.commentsCount }}</span>
        </div>

        <div style="display: flex; margin-left: 0.5rem">
          <span>
            <svg v-if="!publicPage.hasLoginUserGood" width="1em" height="1em" viewBox="0 0 16 16" class="bi-heart heartOff b-icon bi">
              <use :xlink:href="urls.getIconURL('heart')" />
            </svg>
            <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi-heart-fill heartOn b-icon bi">
              <use :xlink:href="urls.getIconURL('heartfill')" />
            </svg>
          </span>
          <span id="countText" style="padding-left: 0.25rem">{{ publicPage.goodCount }}</span>
        </div>
      </div>
      */-->
    </div>
  </div>
</template>


<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import UserBlockSmall from "@/component/parts/UserBlockSmall.vue";
import PublicPageResp from "@/interface/api/PublicPageResp";
import routeState from "@/state/RouteState";
import urls from "@/URLs";


@Options({
  components: {
    UserBlockSmall
  },
  props: {
    publicPage: {
      type: Object,
    },
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  readonly publicPage!: PublicPageResp;
  readonly urls = urls;
  hasImage = true;

  get shortDescrition(){
    if(this.publicPage.description){
      return this.publicPage.description.substring(0, 100)
    }else{
      return '(説明文未設定)'
    }
  }

  get onclickURL(){
    return this.urls.getPublicPageURL(this.publicPage)
    
  }

  onImageError(){
    this.hasImage = false
  }
  // クリック時にアドレス移動
  onClickProject(e:MouseEvent) {
    //ctrl付きクリックの場合は何もせずaタグのリンクをブラウザ機能で別タブで開く
    if(e.ctrlKey){
      return;
    }
    e.preventDefault();
    //プロジェクト画面へ遷移する場合
    routeState.goToPublicPage(this.publicPage);
    
  }

  // いいねボタンを押したときの挙動
  onClickLikeButton() {
    // いいねしていたら
    if (this.publicPage.hasLoginUserGood) {
      this.$root.restAccess.deleteLikesPublicPage(this.publicPage.user.userName, this.publicPage.titleURL).then((res: any) => {
        console.log("プロジェクトをお気に入りから外す :", res);

        if (res.status >= 400) {
          return;
        }
        //状態を逆に
        this.publicPage.hasLoginUserGood = false;

        //カウント数を更新
        this.publicPage.goodCount = res;
        //フォーカスを外す
        (document as any).activeElement.blur();
      });
    } else {
      this.$root.restAccess.putLikesPublicPage(this.publicPage.user.userName, this.publicPage.titleURL).then((res: any) => {
        if (res.status >= 400) {
          return;
        }
        console.log("プロジェクトをお気に入り :", res);
        this.publicPage.hasLoginUserGood = true;
        this.publicPage.goodCount = res;
        (document as any).activeElement.blur();
      });
    }
  }
  get hartColor() {
    return this.publicPage.hasLoginUserGood ? "#F05654" : "#6c757d";
  }
}
</script>

<style lang="scss" scoped>
.projectPanel{
  margin-bottom: 1rem !important;
}
.projectPanelLink {
  text-decoration: none;
  color: inherit;
  border-radius: 4px;
  padding-right: 5px;
  padding-left: 5px;
  transition: background-color .2s;
  
  &:hover{
    background-color: #f9f9fb;
  }
}

.projectTitle {
  text-overflow: ellipsis;
  white-space: nowrap;
}
.heartOff {
  color: "#6c757d";
}

.heartOn {
  color: "#F05654";
}

.thumbnail-wrap{
  width:100%;
  padding-top: 56.25%;
  overflow: hidden;
  position:relative;
}

.thumbnail{
  position:absolute;
  top:0;
  width: 100%;
  height: 100%;
}

.thumbnail-no-image{
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid #666;
}

.thumbnailCard{
    border: 0 !important;
    margin-bottom: 0.5rem !important;
    padding-bottom: 0.25rem !important;
    padding-top: 1rem !important;

    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.25rem;

}

.projectDescription{
  word-break: break-word;
  padding-left: 0.25rem;
  height:3rem;

}

.userBlockWrap{
  overflow-x:hidden;
}
</style>